module.exports = __webpack_public_path__ + "img/front.fd1ecc72.png";